import { render, staticRenderFns } from "./agreementDetail.vue?vue&type=template&id=23246d25&scoped=true&"
import script from "./agreementDetail.vue?vue&type=script&lang=js&"
export * from "./agreementDetail.vue?vue&type=script&lang=js&"
import style0 from "./agreementDetail.vue?vue&type=style&index=0&id=23246d25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23246d25",
  null
  
)

export default component.exports